// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f5117e8e","587":"c9a9c935","687":"876f1f11"}[chunkId] + ".chunk.js";
};